module.exports = __webpack_public_path__ + "media/images/arrow-3a4d2aa10664c0a0c2345308a9144c60.svg";